import axios from "axios";

export const getExportPdfApi = async (
  cookies,
  setMessageResponse,
  setBtnLoader,
  userId
) => {
  const token = cookies.__t0ken_amar_management;
  let config = {
    method: "get",
    responseType: "arraybuffer",
    maxBodyLength: Infinity,
    url: `${process.env.REACT_APP_API}/outgoing-customer-report/${userId}`,
    headers: {
      Accept: "application/pdf",
      Authorization: `Bearer ${token}`,
    },
    timeout: 60000,
  };

  axios(config)
    .then(async (response) => {
      let fileName = response.headers["content-disposition"];
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName.split("filename=")[1]);
      document.body.appendChild(link);
      link.click();
      setBtnLoader(() => false);
    })
    .catch((error) => {
      setBtnLoader(() => false);

      if (error.response) {
        setMessageResponse((prev) => ({
          ...prev,
          success: false,
          message: "حدث خطأ ما يرجى المحاولة لاحقاً",
          isShow: true,
        }));
        setBtnLoader(() => false);
      } else {
        setMessageResponse((prev) => ({
          ...prev,
          success: false,
          message: "تم فقدان الاتصال يرجى الحاولة مرة اخرة لاحقاً",
          isShow: true,
        }));
        setBtnLoader(() => false);
      }
    });
};
